<template lang="html">
  <div class="bar">
    <i class="material-icons menu" @click="onChange">menu</i>
    <div class="text">
      {{this.name}}
    </div>
    <div class="logo-title">
      <img src="../assets/config/config.title-en-US.png" alt="" style="width: 100%;">
    </div>
    <div class="space" @click="showSpaceList">
      <el-badge :is-dot="isDot" class="item">
      </el-badge>
      <div class="per-img">
        <img v-if="space.imgUrl!==''" :src="space.imgUrl" alt="">
        <img v-if="space.imgUrl==''" src="../assets/images/project.png" alt="">
      </div>
      <span class="name">{{ space.name }}</span>
      <i v-if="!show.spaceList" class="material-icons right">keyboard_arrow_right</i>
      <i v-if="show.spaceList" class="material-icons left">keyboard_arrow_left</i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      space: 'space',
      show: 'show',
      notice: 'notice'
    })
  },
  watch: {
    'notice.newPkg': function (val) {
      if (val) {
        if (this.show.spaceList || val.length === 0) {
          this.isDot = false
          return
        }
        var x = 0
        for (var i = 0; i < val.length; i++) {
          if (val[i] === localStorage.getItem('projectId')) {
            x = x + 1
          }
        }
        if (val.length > x) {
          this.isDot = true
        }
      } else {
        this.isDot = false
      }
    },
    '$route': 'barTitle'
  },
  data () {
    return {
      message: {
        Sl109: this.$lang.ui.system.l109,
        Sl110: this.$lang.ui.system.l110,
        Sl227: this.$lang.ui.system.l227,
        Fl108: this.$lang.ui.form.l108
      },
      name: '',
      email: '',
      imgUrl: '',
      userDisplay: 'none',
      isDot: false
    }
  },
  mounted () {
    this.barTitle()
  },
  methods: {
    barTitle () {
      switch (this.$route.name) {
        case 'inbox':
          this.name = this.$lang.ui.system.l109
          break
        case 'outbox':
          this.name = this.$lang.ui.system.l110
          break
        case 'retrieve':
          this.name = this.$lang.ui.system.l233
          break
        case 'transfer':
          this.name = this.$lang.ui.form.l108
          break
        case 'history':
          this.name = this.$lang.ui.system.l227
          break
        case 'portal':
          this.name = this.$lang.ui.app.l192
          break
        case 'statistics':
          this.name = this.$lang.ui.system.l190
          break
        case 'notification':
          this.name = this.$lang.ui.system.l189
          break
        case 'settings':
          this.name = this.$lang.ui.app.l162
          break
        default:
          this.name = ''
          break
      }
    },
    showSpaceList () {
      var data = !this.show.spaceList
      this.isDot = false
      this.$store.dispatch('showSpacelist', data)
    },
    onChange () {
      if (this.show.left) {
        this.$store.dispatch('showLeft', false)
      } else {
        this.$store.dispatch('showLeft', true)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../style/color";
.bar {
  z-index: 1000;
  position: fixed;
  /*background-color: #3a9bd9;*/
  background-color: $primaryColor;
  width: 100%;
  height: 58px;
}
.bar-search {
  position: absolute;
  top: 50%;
  margin-top: -18px;
  left: 280px;
  right: 280px;
}
.bar-search .el-input__inner {
  background-color: #3a9bd9;
  border: 0;
}
.per-img {
  position: absolute;
  overflow: hidden;
  cursor: pointer;
  /*background-color: #fff;*/
  background-color: #3a9bd9;
  top:50%;
  margin-top: -20px;
  left: 18px;
  height: 40px;
  width: 40px;
  border-radius: 40px;
  line-height: 58px;
}
.per-img img {
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 40px;
}
.logo {
  position: absolute;
  cursor: pointer;
  top: 9px;
  left: 56px;
  height: 40px;
  width: 170px;
  overflow: hidden;
}
.text {
  position: absolute;
  left: 68px;
  line-height: 58px;
  top: 0;
  bottom: 0;
  color: #fff;
  font-size: 18px;
}
.menu {
  padding: 2px;
  margin: 15px;
  margin-left: 20px;
  cursor: pointer;
  color: $icons;

}
.space {
  position: absolute;
  cursor: pointer;
  right: 0;
  top: 0;
  padding-right: 15px;
  width: 220px;
  height: 100%;
}
.name {
  position: absolute;
  left: 68px;
  font-size: 18px;
  color: #fff;
  top: 18px;
  right: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  // font-weight: 600;
}
.space i {
  position: absolute;
  font-size: 24px;
  top: 16px;
  color: #fff;
  right: 10px;
}
.space i.right {
  display: none;
}
.space:hover i.right {
  display: block;
}
.item {
  position: absolute;
  z-index: 2;
  top: 9px;
  left: 51px;
}
.logo-title {
  position: absolute;
  width: 280px;
  margin-left: -140px;
  top: 10px;
  left: 50%;
}
</style>
